import api from "../../../core/api";
import { ChangeCustomerContact, CustomerContact } from "../../shared/models/customerContactsModels";

const getRequestConfig = () => {
  return { baseURL: (window as any).app.config.customersApiBaseUrl };
}

class CustomerContactsApi {
  getContacts(): Promise<CustomerContact[]> {
    return api.get<CustomerContact[]>(`/v1/contacts`, getRequestConfig()).then(x => x.data);
  }

  createContact(model: ChangeCustomerContact): Promise<string> {
    return api.post<string>(`/v1/contacts`, model, getRequestConfig())
      .then(x => x.data);
  }

  getContact(id: string): Promise<CustomerContact> {
    return api.get<CustomerContact>(`/v1/contacts/${id}`, getRequestConfig()).then(x => x.data);
  }

  changeContact(id: string, model: ChangeCustomerContact) {
    return api.put<any>(`/v1/contacts/${id}`, model, getRequestConfig()).then(() => null);
  }

  deleteContact(id: string): Promise<any> {
    return api.delete(`/v1/contacts/${id}`, getRequestConfig()).then(() => null);
  }

  changeDefaultContact(id: string) {
    return api.put<any>(`/v1/contacts/${id}/default`, null, getRequestConfig()).then(() => null);
  }
}

export default new CustomerContactsApi();